import React from 'react';

const Service = ({service}) => (
    <div className="service bg-white p-8 shadow-md border border-gray-100">
        <h4 className="service__title text-lg text-primary mb-4">{ service.title }</h4>
        <p className="service__description">{ service.description }</p>
        <p className="text-4xl font-bold"><strong>{ service.price }</strong></p>
        <a href={ service.buttonUrl } className="btn btn--primary mb-8">{ service.buttonText }</a>
        <ul className="text-left space-y-4">
            {
                service.serviceItems.map((item, index) => (
                    <li className="flex" key={ index }><i className="icofont-check-circled mr-2 text-tertiary"></i> <span>{ item }</span></li>
                ))
            }
            
        </ul>
    </div>
);

export default Service;